"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMANENT_RESIDENT_CARD_REGEX = void 0;
exports.PERMANENT_RESIDENT_CARD_REGEX = /^[a-zA-Z]{3}\d{10}$/;
//# sourceMappingURL=permanent-resident-card.js.map